import React, { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Card, createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import Grid from "@mui/material/Grid";
import Navbar from "./ScheduleNavbar";
import { getUser } from "services/auth";
import ScheduleWeek from "./ScheduleWeek";
import {
  todayLocaleDateString,
  calculateCurrentWeek,
  weekHasPendingChanges
} from "./ScheduleHelper";
import { useDispatch, useSelector } from "react-redux";
import {
  scheduledataSelector,
  scheduledata_setToday,
  scheduledata_setCurrentWeekNumber,
  scheduledata_fetchData,
  scheduledata_saveData
} from "reducers/scheduledata/scheduledata";
import { appdataSelector } from "reducers/appdata/appdata";
import { fetchData, menudataSelector } from "reducers/menudata/menudata";
import Button from "@mui/material/Button";
import { useLocation, useParams } from "react-router-dom";

//import logo from "../../../assets/images/besi_logo.png";
import logo from "../../../../assets/images/besi_logo.png";

{
  /*https://react-table.tanstack.com/docs/examples/material-ui-components*/
}

const defaultMaterialTheme = createTheme({
  palette: {
    primary: {
      main: "#008752"
    }
  },
  backdrop: {
    zIndex: 9999999,
    color: "#000"
  }
});

function Schedule(props) {
  const dispatch = useDispatch();
  const scheduleData = useSelector(scheduledataSelector);
  const menudata = useSelector(menudataSelector);
  const appData = useSelector(appdataSelector);
  const location = useLocation();

  useEffect(() => {
    // once on load
    console.log("Schedule - init");

    if ((menudata && !menudata.loaded) || menudata.needsUpdate) {
      console.log("should go get data");
      dispatch(fetchData());
    }

    if (!scheduleData.today) {
      // go get today
      // go get today
      // go get today
      let today = todayLocaleDateString();
      dispatch(scheduledata_setToday(today));
    }

    if (!scheduleData.currentWeekNumber) {
      // set number of current week
      // set number of current week
      // set number of current week
      let currentweeknumber = calculateCurrentWeek();
      dispatch(scheduledata_setCurrentWeekNumber(currentweeknumber));
    }
  }, []);

  useEffect(() => {
    // once on load
    console.log(
      "schedule data updated",
      scheduleData.menus,
      String(scheduleData.selectedWeekNumber)
    );

    if (
      scheduleData.currentWeekNumber &&
      !Object.keys(scheduleData.menus).includes(
        String(scheduleData.selectedWeekNumber)
      )
    ) {
      console.log("schedule should go fetch current week");
      if (scheduleData.errorMessage == "")
        dispatch(scheduledata_fetchData(scheduleData.selectedWeekNumber));
    } else {
      console.log(
        "schedule, current week number already present in store or has error",
        scheduleData
      );
    }

    /* if (haspendingchagnes && !hasPendingChanges){
      setHasPendingChanges(true);
    }
    if (!haspendingchagnes && hasPendingChanges){
      setHasPendingChanges(false);
    } */
  }, [scheduleData]);

  return (
    <Grid
      className="mt-2"
      container
      spacing={2}
      alignItems="top"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Grid item xs={12} md={10}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={defaultMaterialTheme}>
            <Card className="d-print-none">
              <article className="article">
                <div className="container-fluid no-breadcrumb chapter FormIntegration">
                  <Grid container justify="space-between">
                    <Grid item xs={12} sm={6}>
                      <h2 className="article-title">Schedule</h2>
                    </Grid>
                    <Grid item xs={12} sm={6} className="text-sm-right">
                      <h2 className="article-title">
                        Today: {scheduleData.today}
                      </h2>
                    </Grid>
                    {appData.appState != "scheduleprint" && (
                      "Please define the menus that are available to the employees."
                    )}
                  </Grid>

                  <div className="mt-4 mb-4">
                    <Navbar></Navbar>
                  </div>
                </div>
              </article>
            </Card>
            <div className="m-4 text-center d-none d-print-block">
              <img src={logo} alt="BESI" />
            </div>
            <div className="mt-2">
              <ScheduleWeek></ScheduleWeek>
            </div>
            {scheduleData && appData.appState == "schedule" && (
              <Card className="mt-4 d-print-none">
                <article className="article">
                  <div className="container-fluid no-breadcrumb chapter FormIntegration text-center">
                    {!weekHasPendingChanges(scheduleData) && (
                      <div>There are no unsaved changes</div>
                    )}
                    {weekHasPendingChanges(scheduleData) && (
                      <div>
                        <div style={{ color: "red" }}>
                          <b>BE CAREFUL</b>
                          <br></br>
                          Saving the schedule makes all items available to all
                          users immediately.
                        </div>
                        <Button
                          className="mt-4"
                          variant="contained"
                          onClick={() => {
                            dispatch(scheduledata_saveData());
                          }}
                        >
                          Save changes
                        </Button>
                      </div>
                    )}
                  </div>
                </article>
              </Card>
            )}
            <p></p>

            <div className="d-print-none">
              {getUser()["isAdmin"] && location.pathname.includes('/true') && (
                <Button
                  className="mt-4"
                  variant="contained"
                  href="javascript:window.print();"
                >
                  Print Page
                </Button>
              )}

            </div>
          </ThemeProvider>
        </StyledEngineProvider>
      </Grid>
    </Grid>
  );
}

export default Schedule;
